import React, {useEffect, useState} from 'react';

import {formatDateFromISOString, nowISOString} from '../../../utils/dateFunctions';

export default function Profile({authFetch}) {

    const [user, setUser] = useState([]);


    useEffect(() => {
        const fetchUserProfile = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/user/profile`);
            const data = await response.json();
            setUser(data);
        };

        fetchUserProfile();
    }, [authFetch]);

    const createdAtFormatted = formatDateFromISOString(user.createdAt);
    const lastLoggedInAtFormatted = formatDateFromISOString(user.lastLoggedInAt);
    const timeNowFormatted = formatDateFromISOString(nowISOString());

    return (
        <>
            <h2>Profile</h2>
            <p>
                ID: {user._id}
            </p>
            <p>
                Username: {user.username}
            </p>
            <p>
                Created: {createdAtFormatted}
            </p>
            <p>
                Last logged in: {lastLoggedInAtFormatted}
            </p>
            <p>
                Time now: {timeNowFormatted}
            </p>
            <p>
                <a href="/delete-account" className="linkbutton">Delete Account</a>
            </p>
        </>
    );
}